import { Component, effect, output, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-search-box",
  standalone: true,
  imports: [FormsModule],
  templateUrl: "./search-box.component.html",
  styleUrl: "./search-box.component.css",
})
export class SearchBoxComponent {
  searchTerm = signal("");
  search = output<string>();
  private lastValue = "";

  private readonly debounceMs = 400;
  private debounceTimer: any;

  constructor() {
    effect(() => {
      const term = this.searchTerm();
      if (term === this.lastValue) return;
      this.lastValue = term;
      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.search.emit(term.trim());
      }, this.debounceMs);
    });
  }
}
